// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React examples
import SimpleInfoCard from "custom/Cards/InfoCards/SimpleInfoCard";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";


function Information() {
  return (
    <MKBox component="section" py={6} mt={6}>
      <Container>
        <Grid container spacing={3} item xs={12} lg={8} mx="auto">
          <MKTypography variant="h3" mb={7}>
            ¿Qué es el Ransomware?
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            El ransomware es un tipo de software malicioso que encripta los datos de un individuo u organización, dejándolos inaccesibles. Los atacantes exigen un pago de rescate, a menudo en criptomonedas, a cambio de una clave de descifrado para desbloquear los datos encriptados.
          </MKTypography>
          <MKTypography variant="h3" mb={7} mt={7}>
            Aspectos Clave para la Preparación contra Ransomware
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="safety_check"
                title="Medidas Preventivas"
                description="La preparación contra ransomware comienza con la prevención proactiva. Esto incluye implementar medidas robustas de ciberseguridad, actualizar regularmente el software y los parches de seguridad, y educar a los usuarios sobre los peligros de correos electrónicos de phishing y archivos adjuntos maliciosos."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="settings_backup_restore"
                title="Copia de Seguridad y Recuperación"
                description="Las organizaciones deben contar con estrategias integrales de respaldo y recuperación de datos. Esto asegura que, en caso de un ataque de ransomware, los datos puedan ser restaurados sin necesidad de pagar el rescate."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="format_list_numbered"
                title="Planificación de Respuesta a Incidentes"
                description="La preparación contra ransomware incluye desarrollar y probar planes de respuesta a incidentes específicos para este tipo de ataques. Esto incluye roles y responsabilidades claramente definidos, planes de comunicación y pasos para aislar y contener la amenaza."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="school"
                title="Capacitación de Empleados"
                description="La capacitación de los usuarios finales es crucial para prevenir ataques de ransomware. Los programas de formación enseñan a los empleados a reconocer intentos de phishing y enlaces sospechosos, reduciendo la probabilidad de una infección exitosa."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="timeline"
                title="Pruebas Regulares"
                description="Los servicios de preparación contra ransomware a menudo incluyen pruebas regulares de los procesos de respaldo y recuperación, así como de los planes de respuesta a incidentes para garantizar su efectividad cuando sean necesarios."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            ¿Por qué Importa la Preparación contra Ransomware?
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="lock"
                title="Protección de Datos"
                description="La respuesta a incidentes asegura que los incidentes de seguridad se aborden rápidamente, minimizando el impacto en las operaciones y los datos."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="work"
                title="Continuidad Operacional"
                description="Muchos sectores e industrias tienen requisitos legales y regulatorios para la notificación y respuesta a incidentes, lo que hace que sea crucial para cumplir con las normativas."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="credit_score"
                title="Resiliencia Financiera"
                description="Una respuesta bien ejecutada puede ayudar a preservar la reputación y la confianza de una organización ante clientes y partes interesadas."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="record_voice_over"
                title="Gestión de la Reputación"
                description="El análisis post-incidente genera recomendaciones para mejorar las medidas de seguridad, haciendo que una organización sea más resiliente ante futuras amenazas."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            El Rol de la Preparación contra Ransomware en la Ciberseguridad
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            La preparación contra ransomware es un componente vital de la ciberseguridad moderna. Empodera a organizaciones e individuos para defenderse proactivamente contra amenazas de ransomware, minimizar su impacto y recuperarse rápidamente sin tener que pagar rescates. Al implementar estrategias y servicios de preparación contra ransomware, las organizaciones pueden proteger sus activos digitales y garantizar la continuidad del negocio en un entorno donde los ataques de ransomware son cada vez más comunes y sofisticados.
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
